require('bootstrap/dist/css/bootstrap.min.css')
require('@fortawesome/fontawesome-pro/css/fontawesome.min.css')
require('@fortawesome/fontawesome-pro/css/solid.min.css')
require('../css/style.css')
require('../css/responsive.css')

require('../img/great-bg.png')
require('../img/logo.svg')
require('../img/outbound-link.png')
require('../img/favicon.png')
